import React, { useState, useEffect } from 'react';
import image1 from "../../assets/others/ALBAR-IM.jpg"


const Albarothers = () => {
  const imageData = [
    {
      imageUrl: image1,
      title: 'Albar IM Tab',
      description: 'Albendazole 400mg + Ivermectin 6mg',
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to update the current index and trigger a re-render
  const changeSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageData.length);
  };

  useEffect(() => {
    // Change slide every 3 seconds
    const interval = setInterval(changeSlide, 4000);

    // Clear the interval when the component unmounts
    return () => clearInterval(interval);
  });

  return (
    <div className="container mb-5">
    <div className="row">
      <div className="">
        <div className="card-products">
          <img
            src={imageData[currentIndex].imageUrl}
            alt={imageData[currentIndex].title}
            className="custom-image-height"
          />
          <div className="card-body-products">
            <h4 className='card-products-title'><b>  {imageData[currentIndex].title}</b></h4>
            <span className="author-products mt-4">{imageData[currentIndex].description}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Albarothers;
